import React from 'react';
import { AppServices } from 'services/AppServices';
import Locale, { LanguageCode, isSupportedLanguage } from 'localization/Localization';
import { UserData } from 'models/UserData';
import moment from 'moment';

export const UserContext = React.createContext<UserData>({});

export class UserProvider extends React.Component<{}, UserData> {

	static getData: () => Readonly<UserData>;
	static setLanguage: (lang: LanguageCode) => void;
	static getLanguage: () => LanguageCode;
	static refresh: () => Promise<boolean>;
	static clear: () => void;

	constructor(props: {}) {
		super(props);

		this.state = {};

		this._getData = this._getData.bind(this);
		this._getLanguage = this._getLanguage.bind(this);
		this._setLanguage = this._setLanguage.bind(this);
		this._refresh = this._refresh.bind(this);
		this._clear = this._clear.bind(this);

		UserProvider.getData = this._getData.bind(this);
		UserProvider.getLanguage = this._getLanguage.bind(this);
		UserProvider.setLanguage = this._setLanguage.bind(this);
		UserProvider.refresh = this._refresh.bind(this);
		UserProvider.clear = this._clear.bind(this);
	}

	public render() {
		return (
			<UserContext.Provider value={this.state}>
				{this.props.children}
			</UserContext.Provider>
		);
	}

	private _getData(): Readonly<UserData> {
		return this.state;
	}

	private async _refresh(): Promise<boolean> {
		console.debug('UserProvider refreshing');
		return AppServices.userService.getUser()
			.then(data => {
				this.setState(data || {});
				return true;
			})
			.catch(reason => {
				this.setState({});
				console.debug(reason);
				return false;
			})
	}

	private _clear() {
		this.setState({});
	}

	private _getLanguage(): LanguageCode {
		if (isSupportedLanguage(this.state.language))
			return this.state.language as LanguageCode;
		else
			return Locale.fallback;
	}

	private _setLanguage(language: LanguageCode) {
		this.setState({ language: language });
		moment.locale(language);
	}
}

export const UserConsumer = UserContext.Consumer;